import React, { useEffect, useRef } from "react";
import { makeStyles } from "@material-ui/core";
import mail from "../assets/images/email-floating.svg";
import close from "../assets/images/close-popup.svg";
import formName from "../assets/images/form-name.svg";
import formOtp from "../assets/images/form-otp.svg";
import formMail from "../assets/images/form-mail.svg";
import formContact from "../assets/images/form-contact.svg";
import formNameChange from "../assets/images/form-name-golden.svg";
import formMailChange from "../assets/images/form-mail-golden.svg";
import formContactChange from "../assets/images/form-contact-golden.svg";
import formOtpChange from "../assets/images/form-otp-golden.svg";
import { useState } from "react";
import { Modal, Box, TextField } from "@material-ui/core";
import "./mail.css";
import { validateOTP, sendEnteredOTP } from "../services/request/otp";
import { sender } from "../utils/sendMail";

import Timer from "../commomComponents/OtpTimer";

import { getEmailTemplate } from "../utils/getEmailTemplate";

import {
  encrypt,
  decrypt,
  generateSecreteKey,
  createRequestIds,
} from "../services/encryptionDecryptionService";
import setEnquiryDetails from "../services/setRequest/setEnquiryDetails";
import {
  EMAIL_PLACEHOLDER,
  ENTER_VALID_CONTACT_NUMBER,
  ENTER_VALID_EMAIL,
  ENTER_VALID_NAME,
  ENTER_VALID_OTP,
  OTP_SENT_SUCCESSFULLY,
  TOAST_COMMON_API_ERROR,
  TOAST_COMMON_ERROR,
  TOAST_COMMON_OTP_SUCCESS,
  TOAST_COMMON_SUCCESS,
  encryptDecryptKey,
} from "../constants/Constants";
import toast from "react-hot-toast";
import { hashWithSHA256, isEmailValid } from "../utils/commonFunctions";
// import SendOTPbtn from "./SendOTPbtn";

export default function Mail() {
  const [open, setOpen] = React.useState(false);
  const [otpClass, setOtpClass] = React.useState(false);
  const [isActive, setIsActive] = useState(false);
  const [countryCode, setCountryCode] = React.useState(false);
  const [dataLabel, setDataLabel] = React.useState(false);
  const [otp1, setOtp1] = React.useState("");
  const [otp2, setOtp2] = React.useState("");
  const [otp3, setOtp3] = React.useState("");
  const [otp4, setOtp4] = React.useState("");
  const [otp5, setOtp5] = React.useState("");
  const [otp6, setOtp6] = React.useState("");
  const [otp, setOtp] = React.useState("");
  const [changeImage, setChangeImage] = React.useState(false);
  const [changeMail, setChanEemail] = React.useState(false);
  const [changeContact, setChangeContact] = React.useState(false);
  const [changeOtp, setChangeOtp] = React.useState(false);
  const [fullname, setFullName] = React.useState("");
  const [nameErrorMsg, setNameErrorMsg] = React.useState(false);
  const [email, setEmail] = React.useState("");
  const [emailErrorMsg, setEmailErrorMsg] = React.useState(false);
  const [contactNumber, setContactNumber] = React.useState("");
  const [numberErrorMsg, setNumberErrorMsg] = React.useState(false);
  const [otpErrorMsg, setOtpErrorMsg] = React.useState(false);
  const [errorMsg, setErrorMsg] = React.useState(false);
  const [otpSent, setOtpSent] = React.useState(false);
  const [otpBtnText, setOtpBtnText] = React.useState("Send OTP");
  const [isFocused, setIsFocused] = useState(false);
  const [isBlur, setIsBlur] = useState(false);
  const [isFocusedEmail, setIsFocusedEmail] = useState(false);
  const [isBlurEmail, setIsBlurEmail] = useState(false);
  const [requestId, setRequestId] = React.useState(0);
  const [requestIDs, setRequestIds] = React.useState([]);

  const [otpVerified, setOtpVerified] = React.useState(false);
  const [mobVerified, setMobVerified] = React.useState(false);
  const [customMessage, setCustomMessage] = useState("");

  const [otpData, setOtpData] = React.useState({});
  const otpInput1Ref = useRef(null);
  const [chkOtp, setChkOtp] = useState("");
  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setFullName("");
    setEmail("");
    setContactNumber("");
    setOtp1("");
    setOtp2("");
    setOtp3("");
    setOtp4("");
    setOtp5("");
    setOtp6("");
    setOtpData({});
    setOtpSent(false);
    setDataLabel(false);
    setOtpSent(false);
    setOtpVerified(true);
    setMobVerified(false);
    setOtpErrorMsg("");
    setCustomMessage("");
  };

  async function validateEnteredOTP(num) {
    setCustomMessage("Verifying OTP");
    if (num.length == 6) {
      setOtp(num);
      //validateOTP(contactNumber, num);
      let secret = generateSecreteKey(5);
      let reqId = createRequestIds(requestId, secret);
      let reqIds = requestIDs;
      reqIds.push(reqId);
      setRequestIds(reqIds);
      console.log("reqId:" + reqId.requestId);
      let payload = {
        mobileNo: contactNumber,
        otp: parseInt(num),
        // txnId: reqId.requestId,
      };

      let encrypted = encrypt(payload, secret);

      let response = await validateOTP(JSON.stringify(encrypted));
      console.log("Response validateOTP : ", response);
      var ENCRYPTED_KEY = changeRequestId(response.data.part2);
      // let decryptedData = decrypt(response.data.part1, ENCRYPTED_KEY);
      let decryptedData = decrypt(response.data.part1, encryptDecryptKey);
      console.log("DEcrypted validated", decryptedData);

      setOtpErrorMsg(false);

      if (decryptedData.status == "success") {
        setCustomMessage("OTP verified");
        setOtpVerified(true);
        setMobVerified(true);
        setOtpData({});
        toast.success(TOAST_COMMON_OTP_SUCCESS);
      } else {
        setCustomMessage("Something went wrong");
        setOtpVerified(false);
        setMobVerified(false);
        toast.error(decryptedData.message);
      }
    } else {
      setOtpErrorMsg(true);
    }
  }

  function isPhoneEntered() {
    if (contactNumber) {
      setNumberErrorMsg(false);
    } else {
      setNumberErrorMsg(true);
    }
  }

  function handleTextChange(text) {
    let num = /^-?\d*$/.test(text);
    if (num) {
      setIsActive(false);
      setContactNumber(text);
      setNumberErrorMsg(false);
    } else {
      setNumberErrorMsg(true);
    }
  }

  function handleChangeOtp1(event) {
    let num = /^-?\d*$/.test(event.target.value);
    if (num) {
      setOtp1(event.target.value);
      setOtpErrorMsg(false);
      setDataLabel(true);
    } else {
      setDataLabel(false);
    }
  }
  function handleChangeOtp2(event) {
    let num = /^-?\d*$/.test(event.target.value);
    if (num) {
      setOtp2(event.target.value);
      setOtpErrorMsg(false);
      setDataLabel(true);
    } else {
      setDataLabel(false);
    }
  }
  function handleChangeOtp3(event) {
    let num = /^-?\d*$/.test(event.target.value);
    if (num) {
      setOtp3(event.target.value);
      setOtpErrorMsg(false);
      setDataLabel(true);
    } else {
      setDataLabel(false);
    }
  }
  function handleChangeOtp4(event) {
    let num = /^-?\d*$/.test(event.target.value);
    if (num) {
      setOtp4(event.target.value);
      setOtpErrorMsg(false);
      setDataLabel(true);
    } else {
      setDataLabel(false);
    }
  }
  function handleChangeOtp5(event) {
    let num = /^-?\d*$/.test(event.target.value);
    if (num) {
      setOtp5(event.target.value);
      setOtpErrorMsg(false);
      setDataLabel(true);
    } else {
      setDataLabel(false);
    }
  }
  function handleChangeOtp6(event) {
    let num = /^-?\d*$/.test(event.target.value);
    if (num) {
      setOtp6(event.target.value);
      setOtpErrorMsg(false);
      setDataLabel(true);
    } else {
      setDataLabel(false);
    }
  }

  function handleImageChangeFormName() {
    setChangeImage(true);
  }
  function handleChangeImageFormName() {
    setChangeImage(false);
  }
  function handleImageChangeFormMail() {
    setChanEemail(true);
  }
  function handleChangeImageFormMail() {
    setChanEemail(false);
  }
  function handleImageChangeFormContact() {
    setChangeContact(true);
  }
  function handleChangeImageFormContact() {
    setChangeContact(false);
  }
  function handleImageChangeFormOtp() {
    setChangeOtp(true);
  }
  function handleChangeImageFormOtp() {
    setChangeOtp(false);
  }
  function handleChangeName(event) {
    let alphabets =
      /^[\u00C0-\u017Fa-zA-Z'’‘’][\u00C0-\u017Fa-zA-Z’‘’' ' ']+[\u00C0-\u017Fa-zA-Z'’‘’]?$/;
    let name = event.target.value;

    setFullName(name);
    if (name.match(alphabets)) {
      setNameErrorMsg(false);
    } else if (name.match(/^[A-Z]*$/)) {
      setNameErrorMsg(false);
    } else {
      setNameErrorMsg(true);
    }
  }
  function handleEmailChange(event) {
    let email = event.target.value;
    setEmail(email);
  }

  function handleInput() {
    // setDataLabel(!dataLabel);
    setOtpClass(true);
  }

  function changeRequestId(txnId) {
    var secret = "";
    console.warn(JSON.stringify(requestIDs));
    var latest = requestIDs.filter(function (val) {
      console.log("val", val);
      if (val.requestId === txnId) {
        secret = val.secret.substring(
          0,
          val.secret.length - val.requestId.length
        );
        return false;
      }
      return true;
    });
    setRequestIds(latest);
    return secret;
  }

  async function sendOTP() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "leadOtp_generate",
      inquiryType: "",
      buttonName: "Send OTP",
      email: "", // Encrypted email of the User using SHA-256 encryption
      contactNumber: "", // Encrypted contact Number of the User using SHA-256 encryption
      clientID: "",
      queryMessage: "",
      state: "",
      pageSection: "ENQUIRY",
      Category: "",
      FAQ: "",
    });
    if (contactNumber.length < 10) {
      return;
    }
    setOtpSent(true);
    otpInput1Ref.current.focus();
    if (!contactNumber) {
      return;
    }
    const regexExp = /^[6-9]\d{9}$/gi;

    if (!regexExp.test(contactNumber)) {
      return;
    }
    setDataLabel(true);

    let secret = generateSecreteKey(5);
    let reqId = createRequestIds(requestId, secret);
    let reqIds = requestIDs;
    reqIds.push(reqId);
    setRequestIds(reqIds);
    console.log("reqId:" + reqId.requestId);
    let payload = {
      mobileNo: contactNumber,
      //"otp":otp,
      // txnId: reqId.requestId,
    };

    let encrypted = encrypt(payload, secret);

    let response = await sendEnteredOTP(JSON.stringify(encrypted));
    console.log("first", response);
    var ENCRYPTED_KEY = changeRequestId(response.data.part2);
    // let decryptedData = decrypt(response.data.part1, ENCRYPTED_KEY);
    let decryptedData = decrypt(response.data.part1, encryptDecryptKey);
    console.log("DEcrypted dta", decryptedData);
    if (decryptedData.statusCode === 429) {
      toast.error(decryptedData.message);
      setOtpSent(false);
      return;
    }
    if ((decryptedData.status = "success")) {
      toast.success(OTP_SENT_SUCCESSFULLY);
    } else {
      toast.error(TOAST_COMMON_API_ERROR);
    }
    setOtpData(decryptedData);
    setOtpSent(true);
  }

  async function handleSubmit() {
    const hashedEmail = await hashWithSHA256(email);
    const hashedMobile = await hashWithSHA256(contactNumber);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "enquiry_submit",
      inquiryType: "",
      buttonName: "SUBMIT",
      email: hashedEmail, // Encrypted email of the User using SHA-256 encryption
      contactNumber: hashedMobile, // Encrypted contact Number of the User using SHA-256 encryption
      clientID: "",
      queryMessage: "",
      state: "",
      pageSection: "ENQUIRY",
      Category: "",
      FAQ: "",
    });

    if (fullname === "") {
      setErrorMsg(true);
      setNameErrorMsg(true);
    } else {
      setErrorMsg(false);
    }
    if (email === "") {
      setEmailErrorMsg(true);
    } else if (email !== "") {
      if (isEmailValid(email)) {
        setEmailErrorMsg(false);
      } else {
        setEmailErrorMsg(true);
      }
    }
    if (contactNumber === "") {
      setNumberErrorMsg(true);
    } else {
      setNumberErrorMsg(false);
    }
    if (
      otp1 === "" ||
      otp2 === "" ||
      otp3 === "" ||
      otp4 === "" ||
      otp5 === "" ||
      otp6 === ""
    ) {
      setOtpErrorMsg(true);
    } else {
      setOtpErrorMsg(false);
    }

    if (!fullname || !email || !contactNumber || !mobVerified) {
      return;
    } else {
      let secret = generateSecreteKey(5);
      let reqId = createRequestIds(requestId, secret);
      let reqIds = requestIDs;
      reqIds.push(reqId);
      setRequestIds(reqIds);
      console.log("reqId:" + reqId.requestId);
      let payload = {
        fullName: fullname,
        email: email,
        contactNo: contactNumber,
        // txnId: reqId.requestId,
      };

      let encrypted = encrypt(payload, secret);
      let response = await setEnquiryDetails(JSON.stringify(encrypted));
      console.log("Response 1: ", response);
      var ENCRYPTED_KEY = changeRequestId(response.data.part2);
      // let decryptedData = decrypt(response.data.part1, ENCRYPTED_KEY);
      let decryptedData = decrypt(response.data.part1, encryptDecryptKey);
      console.log("DEcrypted dta", decryptedData);
      if (decryptedData.status == "success") {
        // alert("Successfully sent");
        // window.location.reload();
        toast.success(TOAST_COMMON_SUCCESS);
        handleClose();
      } else {
        // alert("Something went wrong");
        toast.error(TOAST_COMMON_ERROR);
      }
    }
  }

  const handleOTPfocus = async (e) => {
    //document.querySelector('input[id="otp2"]').focus()
    if (e.target.dataset["prev"] == "_otp5") {
      let _otp =
        "" +
        window.document.getElementById("_otp1").value +
        window.document.getElementById("_otp2").value +
        window.document.getElementById("_otp3").value +
        window.document.getElementById("_otp4").value +
        window.document.getElementById("_otp5").value +
        window.document.getElementById("_otp6").value;
      if (chkOtp !== _otp && _otp.length === 6) {
        setChkOtp(_otp);
        await validateEnteredOTP(_otp);
      }
    }
    if (
      (e.key === "Delete" || e.key === "Backspace") &&
      e.target.dataset["prev"]
    ) {
      setCustomMessage("");
      document
        .querySelector('input[id="' + e.target.dataset["prev"] + '"]')
        .focus();
    } else if (e.target.dataset["next"]) {
      setCustomMessage("");
      document
        .querySelector('input[id="' + e.target.dataset["next"] + '"]')
        .focus();
    } else {
      setCustomMessage("Verifying OTP");
    }
  };

  function setOtpSentToFalse() {
    setOtpSent(false);
    setOtpBtnText("Resend OTP");
  }

  const styles = useStyles();

  useEffect(() => {}, [customMessage]);

  return (
    <div className={styles.popout}>
      <div className={styles.btnpanel}>
        <img
          src={mail}
          alt="email-floating"
          onClick={() => {
            handleOpen();
          }}
        />

        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={open}
          onClose={handleClose}
        >
          <div className={`enquiryLayout ${styles.paper}`}>
            <div className={styles.closeicon}>
              <img
                src={close}
                alt="close-popup"
                onClick={() => {
                  setOtpSent(false);
                  setOtpBtnText("Send OTP");
                  handleClose();
                }}
              />
            </div>
            <h5 className={styles.heading}>ENQUIRY</h5>
            <p className={styles.para}>
              Please fill this form to schedule a call back with one of our
              agents
            </p>
            <div className={styles.inputForm}>
              <Box component="form" autoComplete="off">
                <div style={{ marginTop: "19px" }}>
                  <div className={`mailInputWrapper ${styles.inputwrapper}`}>
                    <div
                      onMouseOver={handleImageChangeFormName}
                      onMouseLeave={handleChangeImageFormName}
                    >
                      {changeImage ? (
                        <img src={formNameChange} alt="form-name-golden" />
                      ) : (
                        <img src={formName} alt="form-name" />
                      )}
                    </div>
                    <div
                      className={`textFieldContainer ${
                        isFocused
                          ? "contactfullnameFieldFocus"
                          : "contactfullnameField "
                      }`}
                    >
                      <TextField
                        id="full-name"
                        label={isFocused ? "" : "Full Name"}
                        type="name"
                        inputProps={{ maxLength: 64 }}
                        autoComplete=""
                        InputProps={{ disableUnderline: true }}
                        className={styles.contactTextfield}
                        placeholder="Arjun Kumar"
                        onChange={(e) => handleChangeName(e)}
                        value={fullname}
                        required
                        onFocus={() => setIsFocused(true)}
                        onBlur={() => setIsBlur(true)}
                      />
                    </div>
                  </div>
                  {nameErrorMsg ? (
                    <span className="errorMsgContact">{ENTER_VALID_NAME}</span>
                  ) : (
                    ""
                  )}
                </div>
                <div style={{ marginTop: "19px" }}>
                  <div className={`mailInputWrapper ${styles.inputwrapper}`}>
                    <div
                      onMouseOver={handleImageChangeFormMail}
                      onMouseLeave={handleChangeImageFormMail}
                    >
                      {changeMail ? (
                        <img src={formMailChange} alt="form-mail-golden" />
                      ) : (
                        <img src={formMail} alt="form-mail" />
                      )}
                    </div>
                    <div
                      className={`textFieldContainer ${
                        isFocusedEmail
                          ? "contactemailFieldFocus"
                          : "contactemailField"
                      }`}
                    >
                      <TextField
                        id="email"
                        label={isFocusedEmail ? "" : "Email"}
                        type="email"
                        autoComplete=""
                        InputProps={{ disableUnderline: true }}
                        className={styles.contactTextfield}
                        placeholder={EMAIL_PLACEHOLDER}
                        required
                        value={email}
                        inputProps={{ maxLength: 70 }}
                        onChange={(e) => handleEmailChange(e)}
                        onFocus={() => setIsFocusedEmail(true)}
                        onBlur={() => setIsBlurEmail(true)}
                      />
                    </div>
                  </div>
                  {emailErrorMsg ? (
                    <span className="errorMsgContact">{ENTER_VALID_EMAIL}</span>
                  ) : (
                    ""
                  )}
                </div>
                <div>
                  <div
                    className={`mailInputWrapper ${styles.contactinputwrapper}`}
                  >
                    <div
                      onMouseOver={handleImageChangeFormContact}
                      onMouseLeave={handleChangeImageFormContact}
                    >
                      {changeContact ? (
                        <img
                          src={formContactChange}
                          alt="form-contact-golden"
                        />
                      ) : (
                        <img src={formContact} alt="form-contact" />
                      )}
                    </div>
                    <div className="contactInput">
                      <div className="contactNumbercode">
                        {countryCode ? (
                          <span className="countryCode">+91-</span>
                        ) : (
                          ""
                        )}{" "}
                        <input
                          type="text"
                          className="contactNumber"
                          onChange={(e) => handleTextChange(e.target.value)}
                          onClick={() => setCountryCode(true)}
                          onBlur={() => {
                            if (!contactNumber) {
                              setCountryCode(false);
                            }
                          }}
                          value={contactNumber}
                          maxLength={10}
                          placeholder="Contact Number"
                        />
                      </div>
                    </div>
                  </div>
                  {numberErrorMsg ? (
                    <span className="errorMsg">
                      {ENTER_VALID_CONTACT_NUMBER}
                    </span>
                  ) : (
                    ""
                  )}
                </div>
                <div
                  className={`sendResendContainer ${styles.otpButtonContainer}`}
                >
                  {!otpSent ? (
                    <a
                      onClick={() => {
                        sendOTP();
                      }}
                      className={`resendOtp ${styles.otpwrapperSend}`}
                    >
                      {otpBtnText}
                    </a>
                  ) : (
                    !otpVerified && (
                      <Timer data={otpData} setOtpSent={setOtpSentToFalse} />
                    )
                  )}
                  {/* <div className={`resendOtp ${styles.otpwrapper}`}>Resend OTP</div> */}
                </div>
                {/* <SendOTPbtn /> */}
                <div>
                  <div className={`mailOtpInput ${styles.otpinputWrapper}`}>
                    <div className={`otpWrapper ${styles.inputwrapper1}`}>
                      <div
                        onMouseOver={handleImageChangeFormOtp}
                        onMouseLeave={handleChangeImageFormOtp}
                      >
                        {changeOtp ? (
                          <img src={formOtpChange} alt="form-otp-golden" />
                        ) : (
                          <img src={formOtp} alt="form-otp" />
                        )}
                      </div>
                      <div className="otpInputfield">
                        <label
                          className={`${dataLabel ? "Active" : "otpLabel"}`}
                        >
                          Provide OTP
                        </label>

                        <div
                          className={`${
                            otpClass ? "giveBorder" : "otpContainer"
                          } `}
                        >
                          <input
                            name="_otp1"
                            ref={otpInput1Ref}
                            type="text"
                            id="_otp1"
                            data-next="_otp2"
                            data-prev="_otp1"
                            autoComplete="off"
                            className="otpInput"
                            value={otp1}
                            onChange={(e) => handleChangeOtp1(e)}
                            tabIndex="1"
                            maxLength="1"
                            onFocus={handleInput}
                            onKeyUp={(e) => handleOTPfocus(e)}
                          />
                          <input
                            name="_otp2"
                            type="text"
                            id="_otp2"
                            data-next="_otp3"
                            data-prev="_otp1"
                            autoComplete="off"
                            className="otpInput"
                            value={otp2}
                            onChange={(e) => handleChangeOtp2(e)}
                            tabIndex="2"
                            maxLength="1"
                            onFocus={handleInput}
                            onKeyUp={(e) => handleOTPfocus(e)}
                          />
                          <input
                            name="_otp3"
                            type="text"
                            id="_otp3"
                            data-next="_otp4"
                            data-prev="_otp2"
                            autoComplete="off"
                            className="otpInput"
                            value={otp3}
                            onChange={(e) => handleChangeOtp3(e)}
                            tabIndex="3"
                            maxLength="1"
                            onFocus={handleInput}
                            onKeyUp={(e) => handleOTPfocus(e)}
                          />
                          <input
                            name="_otp4"
                            type="text"
                            id="_otp4"
                            data-next="_otp5"
                            data-prev="_otp3"
                            autoComplete="off"
                            className="otpInput"
                            value={otp4}
                            onChange={(e) => handleChangeOtp4(e)}
                            tabIndex="4"
                            maxLength="1"
                            onFocus={handleInput}
                            onKeyUp={(e) => handleOTPfocus(e)}
                          />
                          <input
                            name="_otp5"
                            type="text"
                            id="_otp5"
                            data-next="_otp6"
                            data-prev="_otp4"
                            autoComplete="off"
                            className="otpInput"
                            value={otp5}
                            onChange={(e) => handleChangeOtp5(e)}
                            tabIndex="5"
                            maxLength="1"
                            onFocus={handleInput}
                            onKeyUp={(e) => handleOTPfocus(e)}
                          />
                          <input
                            name="_otp6"
                            type="text"
                            id="_otp6"
                            data-prev="_otp5"
                            autoComplete="off"
                            className="otpInput"
                            value={otp6}
                            onChange={(e) => handleChangeOtp6(e)}
                            tabIndex="6"
                            maxLength="1"
                            onFocus={handleInput}
                            onKeyUp={(e) => handleOTPfocus(e)}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  {otpErrorMsg ? (
                    <span className="errorMsg">{ENTER_VALID_OTP}</span>
                  ) : (
                    ""
                  )}
                  {/* {errorMsg ? <span className="errorMsg">Required</span> : ""} */}
                </div>
              </Box>
              <div
                style={{
                  marginTop: "20px",
                  color: "#c9b16d",
                  textAlign: "center",
                }}
              >
                {/* {customMessage && <span>{customMessage}</span>} */}
              </div>
            </div>
            <div
              className={`formSubmit ${styles.submit}`}
              onClick={handleSubmit}
            >
              SUBMIT
            </div>
          </div>
        </Modal>
      </div>
    </div>
  );
}

const useStyles = makeStyles({
  popout: {
    position: "fixed",
    bottom: "3rem",
    right: "3rem",
    zIndex: 99,
  },
  btnpanel: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    cursor: "pointer",
    width: "56px",
    height: "56px",
    color: "#97291e",
    borderRadius: "50%",
    backgroundColor: "#97291e",
    // lineHeight: "60px",
    // textAlign: "center",
    // fontSize: "32px",
    // zIndex: "9999",
    // background: "transparent",
  },
  paper: {
    // width: 450,
    width: 360,
    position: "fixed",
    bottom: "3rem",
    right: "3rem",
    backgroundColor: "#97291e",
    paddingTop: 30,
    paddingRight: 42,
    paddingBottom: 53,
    paddingLeft: 45,
    borderRadius: 8,
    flexBasis: "27%",
    outline: "none",
  },
  closeicon: {
    display: "flex",
    justifyContent: "flex-end",
    marginBottom: 0,
    cursor: "pointer",
  },
  heading: {
    marginTop: 0,
    marginBottom: 12,
    fontSize: 18,
    fontWeight: 600,
    color: "#ffffff",
    textAlign: "left",
    // cursor: "pointer",
  },
  para: {
    fontWeight: "normal",
    color: "#ffffff",
    marginTop: 0,
    marginBottom: "1rem",
    lineHeight: 1.5,
    textAlign: "left",
  },
  inputwrapper: {
    width: "100%",
    // marginTop: 20,
    // marginBottom: 20,
    borderRadius: 25,
    border: "solid 1px ",
    borderColor: "#fafafa",
    backgroundColor: "#ffffff",
    height: 53,
    fontSize: 12,
    display: "flex",
    alignItems: "center",
  },
  inputwrapperMail: {
    width: "100%",
    marginTop: 20,
    // marginBottom: 20,
    borderRadius: 25,
    border: "solid 1px ",
    borderColor: "#fafafa",
    backgroundColor: "#ffffff",
    height: 53,
    fontSize: 12,
    display: "flex",
    alignItems: "center",
  },
  contactinputwrapper: {
    width: "100%",
    marginTop: 20,
    // marginBottom: 20,
    borderRadius: 25,
    border: "solid 1px ",
    borderColor: "#fafafa",
    backgroundColor: "#ffffff",
    height: 53,
    fontSize: 12,
    display: "flex",
    alignItems: "center",
  },
  inputwrapper1: {
    margin: 0,
    width: "100%",
    borderRadius: 25,
    border: "solid 1px #fafafa",
    backgroundColor: "#ffffff",
    height: 53,
    fontSize: 12,
    display: "flex",
    alignItems: "center",
    marginBottom: 20,
  },
  otpinputWrapper: {
    display: "block",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    marginTop: 20,
    height: 50,
  },
  otpwrapper: {
    border: "1px solid #ffffff",
    borderRadius: 28,
    backgroundColor: "#97291e",
    paddingTop: 8,
    paddingBottom: 8,
    paddingLeft: 30,
    paddingRight: 30,
    fontSize: 12,
    fontWeight: "bold",
    lineHeight: 1.33,
    color: "#ffffff",
    cursor: "pointer",
  },
  otpwrapperSend: {
    border: "1px solid #ffffff",
    borderRadius: 28,
    backgroundColor: "#97291e",
    paddingTop: 8,
    paddingBottom: 8,
    paddingLeft: 40,
    paddingRight: 40,
    fontSize: 12,
    fontWeight: "bold",
    lineHeight: 1.33,
    color: "#ffffff",
    cursor: "pointer",
  },
  submit: {
    backgroundColor: "#c9b16d",
    borderRadius: 28,
    marginTop: 30,
    fontWeight: "bold",
    paddingTop: 15,
    paddingRight: 149,
    paddingBottom: 15,
    paddingLeft: 105,
    lineHeight: 1.25,
    color: "#404040",
    cursor: "pointer",
  },
  accform: {
    verticalAlign: "middle",
    borderStyle: "none",
  },
  input: {
    marginTop: 6,
    marginRight: 20,
    marginBottom: 4,
    marginLeft: 0,
    fontSize: 12,
    lineHeight: 1.33,
    color: "#404040",
  },
  mailfullnameField: {
    marginTop: -20,
  },
  otpButtonContainer: {
    width: "100%",
    justifyContent: "space-around",
    marginTop: 20,
    display: "flex",
  },
});
